import React, {useState, useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";
import {Field, Form, Formik} from "formik";
import Loader from "../../loaders/Loader";
import {USER_PROJECT, USER_ROLE} from "../../../constants/Auth";
import {logOut} from "../../../redux/dataUploader/dataSlice";

import "react-tagsinput/react-tagsinput.css";
import './add-item.scss'
import '../../forms/UpdateConfigForm/update-config-form.scss'

const UpdateServiceCredsPopup = ({
                            initialValues,
                            remarksList,
                            setInitialValues,
                            closePopup,
                            isPopupType,
                            setAccountsList,
                            projectsList,
                            usersList,
                            manageCompaniesIdList,
                            setConfirmationMessage,
                            setConfirmationMessageText
                      }) => {
    const dispatch = useDispatch();
    const projectName = localStorage.getItem(USER_PROJECT);
    const role = localStorage.getItem(USER_ROLE);
    const currentItemData = useSelector((state) => state.dataUploader.voluumAlertItem);
    const [fieldsError, setFieldsError] = useState(false);
    const [errorMessages, setErrorMessages] = useState([]);
    const [formError, setFormError] = useState(false);
    const [formLoading, setFormLoading] = useState(false);
    const [formSuccess, setFormSuccess] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const token = localStorage.getItem("auth_token");
    const [credentialsCheckbox, setCredentialsCheckbox] = useState(true);

    const booleanValues = [
        {id: 1,name: true},
        {id: 2, name: false}
    ]
    
    const checkSession = (status) => {
        if(status === 401) {
            dispatch(logOut());
        }
    }

    useEffect(() => {
        setIsLoading(true)
        const currentItemDataLength = Object.keys(currentItemData).length;
        if (currentItemDataLength) {
            setInitialValues(currentItemData);
        }
        setTimeout(() => {
            setIsLoading(false)
        }, 500)
    }, [currentItemData, setInitialValues])

    const validateOther = value => {
        const regex = /^[a-zA-Z0-9 !@#$%^&*()_+\-='"\\|,.?]*$/
        if (value === '') {
            return 'Required field';
        } else if (!regex.test(value)) {
            return 'No special symbols';
        }
    }

    const validateSpecialSymbols = value => {
        if (value === 'Rule') {
            return;
        }
        const regex = /^[a-zA-Z0-9 !@#$%^&*()_+\-='"\\|,.?]*$/
        if (!regex.test(value)) {
            return 'No special symbols';
        }
    }

    const validateNumber = value => {
        if (value === '') {
            return 'Required field';
        } else if (!/^(|-?\d+)$/.test(value)) {
            return 'Numbers only';
        }
    }

    const validateDomain = (value) => {
        if (!value || value.trim() === '') {
            return 'Required field';
        }

        const trimmed = value.trim();

        if (/^https?:\/\//i.test(trimmed)) {
            return 'Do not include http:// or https://';
        }
        if (/^www\./i.test(trimmed)) {
            return 'Do not include www.';
        }

        const domainRegex = /^(?!:\/\/)([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}$/;

        if (!domainRegex.test(trimmed)) {
            return 'Enter valid domain (e.g. example.com)';
        }

        return undefined;
    };

    const nullToEmptyStringsDeep = (v) => {
        if (v === null) return '';
        if (Array.isArray(v)) return v.map(nullToEmptyStringsDeep);
        if (typeof v === 'object' && v) {
            return Object.fromEntries(
            Object.entries(v).map(([k, val]) => [k, nullToEmptyStringsDeep(val)])
            );
        }
        return v;
    };

    const onSubmit = async (values) => {
        
        const toNumberBool = (value) => (value === "true") || (value === true) ? 1 : 0;
        
        const credentialsJSON = JSON.stringify(values.credentials);

        try {
            setFieldsError(false);
            setFormLoading(true);
            setErrorMessages([]);

            const formData = new FormData();

            formData.append('credentials', credentialsJSON);
            formData.append('status', toNumberBool(values.status));
            formData.append('is_archived', toNumberBool(values.is_archived));
            formData.append('offers_parent_id', values.offers_parent_id);
            formData.append('is_main_offers', toNumberBool(values.is_main_offers));
            formData.append('is_main_commissions', toNumberBool(values.is_main_commissions));
            formData.append('commissions_parent_id', values.commissions_parent_id);
            formData.append('check_credentials', toNumberBool(credentialsCheckbox));
        
            const res = await fetch(`${localStorage.getItem('apiUrl')}api/service-credentials/${values.id}`, {
                method: 'POST',
                headers: { 
                    "Authorization": `Bearer ${token}` 
                },
                body: formData
            });

            // api call
            checkSession(res.status);

            const data = await res.json();

            if(data.status) {
                // setAccountsList(data?.accounts?.data || []);
                closePopup();
                setConfirmationMessage(true);
                setConfirmationMessageText(`Service successfully updated`);
            } else {
                const raw = data?.errors ?? data?.error ?? {};

                const errors = Object.values(raw)
                .flatMap(v => Array.isArray(v) ? v : [v])
                .map(v => String(v).trim())
                .filter(Boolean);

                setFieldsError(true);
                setErrorMessages(errors);
            }
        } catch (error) {
            console.error("Server connection error:", error);
            setFieldsError(true);
        } finally {
            setFormLoading(false);
        }
    }

    return (
        <div className='add-item-popup-container'>
            <div className="add-item-popup-block">
                <div className='form-wrap'>
                    <Formik
                        enableReinitialize={true}
                        initialValues={nullToEmptyStringsDeep({
                            ...(initialValues || {}),
                            credentials: (() => {
                            try {
                                const raw = initialValues?.credentials;
                                return raw ? JSON.parse(raw) : {};
                            } catch {
                                return {};
                            }
                            })(),
                        })}
                        onSubmit={onSubmit} 
                        >
                            
                        {({errors, touched}) => (
                            <Form>
                                <div className="title-wrap">
                                    <h1>
                                        {isPopupType === 'updating' ? 'Update' : 'Create new account'}
                                    </h1>
                                    <div className="close-btn" onClick={closePopup}>
                                        <img src={`${process.env.PUBLIC_URL}/images/close-btn.svg`} alt="close popup"/>
                                    </div>
                                </div>
                                {
                                    isLoading ?
                                        <Loader/>
                                        :
                                        <>
                                            <div className="form-flex-container">
                                                {Object.keys(initialValues).map(inputItem => {
                                                    
                                                    if(role !== 'admin' && (inputItem === 'user_id')) return null;

                                                    if(inputItem === 'credentials') {
                                                        const serviceCredentials = JSON.parse(initialValues[inputItem]); 
                                                        return (
                                                            <div className="credentials-cover" key={inputItem}>
                                                                <h4>Credentials</h4>
                                                                {Object.entries(serviceCredentials || {}).map(([key]) => (
                                                                    <div className="input-block without-config-item-block" key={key}>
                                                                        <label htmlFor={`credentials.${key}`}>{key}</label>
                                                                        <Field id={`credentials.${key}`} name={`credentials.${key}`} type="text" />
                                                                    </div>  
                                                                ))}
                                                                <div className='input-block config-item-block checkbox-block'>
                                                                    <Field
                                                                        type="checkbox"
                                                                        className="toggle-button"
                                                                        id='check_credentials'
                                                                        name="check_credentials"
                                                                        checked={credentialsCheckbox}
                                                                        onChange={(e) => setCredentialsCheckbox(e.target.checked)}
                                                                    />
                                                                    <label htmlFor="check_credentials" className="toggle-label">
                                                                        Validate Credentials
                                                                    </label>
                                                                </div>
                                                                {errors[inputItem] && touched[inputItem] ? <div
                                                                    className='form-error'>{errors[inputItem]}</div> : null}
                                                            </div>
                                                        )
                                                    }

                                                    if (inputItem === 'status' || 
                                                        inputItem === 'is_archived' 
                                                        // || inputItem === 'is_main_offers'
                                                    ) {
                                                        return (
                                                            <div
                                                                className={`input-block without-config-item-block${errors[inputItem] && touched[inputItem] ? ' form-error' : ''}`}
                                                                key={inputItem}>
                                                                <label htmlFor={inputItem}
                                                                        className="toggle-label">{inputItem}</label>
                                                                <Field as="select" name={inputItem}>
                                                                    <option key={initialValues[inputItem]}
                                                                        value={String(initialValues[inputItem])}>{String(initialValues[inputItem])}</option>
                                                                        <option key={!initialValues[inputItem]} value={String(!initialValues[inputItem])}>
                                                                            {String(!initialValues[inputItem])}
                                                                        </option>
                                                                </Field>
                                                            </div>
                                                        )
                                                    } 

                                                    if(inputItem === 'id' || 
                                                        inputItem === 'name' || 
                                                        inputItem === 'service_credential_type_id' || 
                                                        inputItem === 'created_at' || 
                                                        inputItem === 'updated_at' || 
                                                        inputItem === 'account' || 
                                                        inputItem === 'magic_company_short_name' || 
                                                        inputItem === 'is_magic_enabled' || 
                                                        inputItem === 'company_id' || 
                                                        inputItem === 'voluum_id' || 
                                                        inputItem === 'blog_id' || 
                                                        inputItem === 'affise_affiliate_id' || 
                                                        inputItem === 'deleted_at' || 
                                                        inputItem === 'offers_parent_id'|| 
                                                        inputItem === 'is_main_offers'|| 
                                                        inputItem === 'is_main_commissions'|| 
                                                        inputItem === 'commissions_parent_id') return null;

                                                    if(role !== 'admin' && (inputItem === 'jv' || inputItem === 'project')) return null;

                                                    return (
                                                        <div className={`input-block without-config-item-block${errors[inputItem] && touched[inputItem] ? ' form-error' : ''}`}
                                                            key={inputItem}>
                                                            <label htmlFor={inputItem}>{inputItem}</label>
                                                            <Field
                                                                id={inputItem}
                                                                name={inputItem}
                                                                type='text'
                                                            />
                                                            {errors[inputItem] && touched[inputItem] ? <div
                                                                className='form-error'>{errors[inputItem]}</div> : null}
                                                        </div>
                                                    )
                                                })}

                                            </div>
                                            <div className="config-btns-block">
                                                <div className="discard-btn" onClick={closePopup}>Discard</div>
                                                <button className='update-btn'
                                                    type="submit">{isPopupType === 'updating' ? 'Update' : 'Create'}</button>
                                            </div>
                                        </>
                                }
                            </Form>
                        )}
                    </Formik>
                    {formLoading ? <div className="config-btns-loader-block"><Loader/></div> : null}
                    {fieldsError ?
                        <div className="config-btns-message-block">
                            {errorMessages.map((item, index) => {
                                return <p key={item[index]} className='new-user-error'>{item}</p>
                            })}
                        </div> : ''}
                    {formError ?
                        <div className="config-btns-message-block"><p className='new-user-error'>Some error occurred</p>
                        </div> : ''}
                    {formSuccess ? <div className="config-btns-message-block"><p className='new-user-success'>Account
                        is {isPopupType === 'updating' ? 'updated' : 'created'}</p></div> : ''}
                </div>
            </div>
        </div>
    )
}

export default UpdateServiceCredsPopup;